import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { roleType, useUser } from '~entities/shared/user';
import { useTranslation } from '~shared/lib/i18n';
import { RoutesUrls } from '~shared/lib/router';
import { AttendanceIcon, EducationIcon, HomeIcon, KidsIcon } from '~shared/ui';

import styles from './mobileNavigation.module.scss';

interface TabItem {
  path: string;
  title: string;
  icon: ReactNode;
  show: roleType[];
}

export interface MobileNavigationProps {}

export const MobileNavigation: FC<MobileNavigationProps> = () => {
  const { t } = useTranslation();
  const user = useUser();

  const tabs: TabItem[] = [
    {
      path: RoutesUrls.parentCabinetHome,
      title: t('cm:pages.parentCabinetHome') as string,
      icon: <HomeIcon />,
      show: ['parent'],
    },
    {
      path: RoutesUrls.parentCabinetChildrenList,
      title: t('cm:pages.kids') as string,
      icon: <KidsIcon />,
      show: ['parent'],
    },
    {
      path: RoutesUrls.parentCabinetEducation,
      title: t('cm:pages.parentCabinetEducation') as string,
      icon: <EducationIcon />,
      show: ['parent'],
    },
    {
      path: RoutesUrls.parentCabinetAttendance,
      title: t('cm:pages.attendance') as string,
      icon: <AttendanceIcon />,
      show: ['parent', 'member'],
    },
    {
      path: RoutesUrls.home,
      title: t('cm:pages.home') as string,
      icon: <HomeIcon />,
      show: ['accelerator', 'directorPreschool'],
    },
    {
      path: RoutesUrls.kids,
      title: t('cm:pages.kids') as string,
      icon: <KidsIcon />,
      show: ['accelerator', 'directorPreschool', 'teacher'],
    },
    {
      path: RoutesUrls.applications,
      title: t('cm:pages.applications') as string,
      icon: <EducationIcon />,
      show: ['accelerator', 'directorPreschool'],
    },
    {
      path: RoutesUrls.attendance,
      title: t('cm:pages.attendance') as string,
      icon: <AttendanceIcon />,
      show: ['accelerator', 'teacher'],
    },
  ];

  const visible = tabs.filter((tab) => tab.show.some((role) => user?.role?.includes(role)));

  if (visible.length === 0) {
    return null;
  }

  return (
    <nav className={styles.wrapper}>
      {visible.map((tab) => (
        <NavLink
          key={tab.path}
          to={tab.path}
          className={({ isActive }) => classNames(styles.tab, isActive && styles.tabActive)}
        >
          {tab.icon}
          <span>{tab.title}</span>
        </NavLink>
      ))}
    </nav>
  );
};
